<header id="page-topbar" class="transition-all duration-300"
        [ngClass]="{
          'ml-0 md:ml-64': sidebarSize === 'lg' || sidebarSize === null,
          'ml-0 md:ml-20': sidebarSize === 'sm',
          'ml-0 md:ml-16': sidebarSize === 'sm-hover'
        }">
  <div class="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="flex h-16 items-center justify-between">
      <!-- Left: Mobile menu button -->
      <div class="flex items-center">
<button type="button"
        id="topnav-hamburger-icon"
        class="inline-flex h-10 w-10 items-center justify-center rounded-md hover:bg-gray-50 transition-colors -ml-5"
        (click)="onToggleMobileMenu($event)">
  <span class="sr-only">Open sidebar</span>

  <svg xmlns="http://www.w3.org/2000/svg"
       width="20"
       height="20"
       viewBox="0 0 24 24"
       fill="none"
       stroke="currentColor"
       stroke-width="2"
       stroke-linecap="round"
       stroke-linejoin="round"
       class="lucide lucide-panel-left text-gray-700">
    <rect width="18" height="18" x="3" y="3" rx="2"/>
    <path d="M9 3v18"/>
  </svg>

</button>

      </div>

      <!-- Right: User menu -->
      <div class="flex items-center gap-3 ml-auto">
        <app-daisy-dropdown #userDropdown>
          <button dropdown-toggle
                  id="page-header-user-dropdown"
                  type="button"
                  class="flex items-center gap-2 rounded-lg p-2 hover:bg-gray-50 transition-colors"
                  aria-haspopup="true"
                  aria-expanded="{{ userDropdown.isOpen() }}">
            <span class="flex items-center">
              <img class="h-8 w-8 rounded-full object-cover ring-2 ring-gray-200"
                   src="assets/images/users/user-dummy-img.jpg"
                   alt="Header Avatar" />
              <span class="ml-2 hidden xl:flex flex-col text-left">
                <span class="text-sm font-semibold text-gray-900">{{ authUser?.name }}</span>
                <span class="text-xs text-gray-500">
                  {{ authUserRole }}<span *ngIf="isSystemAdmin && retailer"> - {{ retailer.name }}</span>
                </span>
              </span>
              <svg xmlns="http://www.w3.org/2000/svg" class="ml-1 w-4 h-4 text-gray-500 transition-transform" [class.rotate-180]="userDropdown.isOpen()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m6 9 6 6 6-6"/>
              </svg>
            </span>
          </button>

        <ul dropdown-menu
    class="bg-transparent px-1 py-1">

            <li class="px-4 py-3 border-b border-gray-200">
              <p class="text-sm font-semibold text-gray-900">{{ authUser?.name }}</p>
              <p class="text-xs text-gray-500 mt-0.5">Welcome back!</p>
            </li>

            <li>
              <a class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                 [routerLink]="['/', 'account']"
                 (click)="userDropdown.close()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                <span>Profile</span>
              </a>
            </li>

            <li *ngIf="isSystemAdmin">
              <a class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                 [routerLink]="['/', 'system', 'switch-retailer']"
                 (click)="userDropdown.close()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4"/>
                  <path d="m21 2-9.6 9.6"/>
                  <circle cx="7.5" cy="15.5" r="5.5"/>
                </svg>
                <span>Switch Retailer</span>
              </a>
            </li>

            <li *ngIf="isSystemAdmin">
              <a class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                 [routerLink]="['/', 'system', 'feeds-dashboard']"
                 (click)="userDropdown.close()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 11a9 9 0 0 1 9 9"/>
                  <path d="M4 4a16 16 0 0 1 16 16"/>
                  <circle cx="5" cy="19" r="1"/>
                </svg>
                <span>Feed Monitor</span>
              </a>
            </li>

            <li *ngIf="isSystemAdmin">
              <a class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                 [routerLink]="['/', 'system', 'token-monitor']"
                 (click)="userDropdown.close()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="7.5" cy="15.5" r="5.5"/>
                  <path d="m21 2-9.6 9.6"/>
                  <path d="m15.5 7.5 3 3L22 7l-3-3"/>
                </svg>
                <span>Token Monitor</span>
              </a>
            </li>

            <li class="my-1">
              <div class="border-t border-gray-200"></div>
            </li>

            <li>
              <a class="flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                 href="javascript:void(0);"
                 (click)="userDropdown.close(); onLogout()">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-3 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" x2="9" y1="12" y2="12"/>
                </svg>
                <span>Logout</span>
              </a>
            </li>
          </ul>
        </app-daisy-dropdown>
      </div>
    </div>
  </div>
</header>